export default __webpack_public_path__ + "static/media/humberto-jeronymo.5024b72b.jpg";